import { toast } from 'react-hot-toast';
import CustomToast from '@Common/toast/CustomToast';

const showToast = {
  success: (message: string, testId?: string) =>
    toast.custom((t) => (
      <CustomToast t={t} type="success" message={message} testId={testId} />
    )),

  error: (message: string, testId?: string) =>
    toast.custom((t) => (
      <CustomToast t={t} type="error" message={message} testId={testId} />
    )),

  warning: (message: string, testId?: string) =>
    toast.custom((t) => (
      <CustomToast t={t} type="warning" message={message} testId={testId} />
    )),

  info: (message: string, testId?: string) =>
    toast.custom((t) => (
      <CustomToast t={t} type="info" message={message} testId={testId} />
    )),

  loading: (message: string, testId?: string) => {
    const id = toast.custom((t) => (
      <CustomToast t={t} type="loading" message={message} testId={testId} />
    ));

    return id;
  },

  promise: async <T,>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string;
      error: string;
      testId?: string;
    }
  ) => {
    const toastId = showToast.loading(messages.loading, messages.testId);
    try {
      const result = await promise;
      toast.dismiss(toastId);
      showToast.success(messages.success);
      return result;
    } catch (error) {
      toast.dismiss(toastId);
      showToast.error(messages.error);
      throw error;
    }
  },
};

export default showToast;
